import { render, staticRenderFns } from "./IndexTwo.vue?vue&type=template&id=69bd2f38"
import script from "./IndexTwo.vue?vue&type=script&lang=js"
export * from "./IndexTwo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports